import React, { FunctionComponent, useEffect, useState } from 'react'
import localforage from 'localforage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './styles.module.css'
import { useToggle } from '../../utils/customHooks'

export interface Props {
  tableHash: string
  cols: any
  onSetHiddenCols: (cols: string[]) => void
}

const TableColFilter: FunctionComponent<Props> = ({
  tableHash,
  cols,
  onSetHiddenCols,
}) => {
  const localStorageKey = `table.${tableHash}.settings.hiddenCols`
  const [hiddenCols, setHiddenCols] = useState<string[]>([])
  const [showCols, toggleShowCols] = useToggle(false)

  useEffect(() => {
    onSetHiddenCols(hiddenCols)
  }, [hiddenCols])

  useEffect(() => {
    localforage.getItem<string[]>(localStorageKey, (error, settings) => {
      setHiddenCols(settings ? settings : [])
    })
  }, [])

  const setFieldFilter = async ({ target: { value, checked } }) => {
    const existing = await localforage.getItem<string[]>(localStorageKey)

    let hiddenCols = existing || []

    if (!checked) {
      hiddenCols.push(value)
    } else {
      hiddenCols = hiddenCols.filter(v => v !== value)
    }

    setHiddenCols(hiddenCols)
    localforage.setItem(localStorageKey, hiddenCols)
  }

  return (
    <div className={styles.hiddenCols}>
      {hiddenCols.length > 0 && (
        <div className={styles.hiddenColCount}>
          Hiding {hiddenCols.length} column{hiddenCols.length > 1 && 's'}
        </div>
      )}
      <FontAwesomeIcon
        icon={['fas', 'cog']}
        className={styles.cog}
        onClick={toggleShowCols}
      />
      {showCols && (
        <div className={styles.colList}>
          <span>Show Columns</span>
          {cols.map(c => {
            if (!c.field || !c.text) return null
            return (
              <div key={c.field}>
                <input
                  type="checkbox"
                  onChange={setFieldFilter}
                  value={c.field}
                  checked={!hiddenCols.includes(c.field)}
                  id={c.field}
                />
                <label htmlFor={c.field}>{c.text}</label>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default TableColFilter
